import { Box } from '@mui/material'
import { useTableCopy } from './useTableCopy.js'
import TableCopyButton from './TableCopyButton.jsx'
import TableGrid from './TableGrid.jsx'

export default function TableView({ data }) {
  const { copied, handleCopy, headers } = useTableCopy(data)
  if (!data?.length) return null
  return (
    <Box sx={{ position: 'relative', my: '8px', '&:hover .copy-btn': { opacity: 1 } }}>
      <TableCopyButton copied={copied} onCopy={handleCopy} />
      <TableGrid data={data} headers={headers} />
    </Box>
  )
}
